<template>
  <div
    :class="componentClass"
    :style="componentStyle"
  >
    <font-awesome-icon
      v-if="hasIcon"
      :icon="$v7[iconStyle][iconName]"
      :rotation="iconRotation"
      class="decorative"
    />

    <slot name="title">
      <h4
        v-if="hasTitle"
        class="h5"
      >
        {{ title }}
      </h4>
    </slot>

    <slot name="content">
      <p
        v-if="hasContent"
        style="--paragraph-margin-bottom: 0"
      >
        {{ content }}
      </p>
    </slot>

    <button
      type="button"
      class="close"
      :aria-label="ariaLabelClose"
      data-balloon-pos="up-right"
      style="--with-close-close-font-size: var(--font-size-md); top: 1rem; right: 1rem"
      @click="dismissNudge"
    >
      <font-awesome-icon :icon="$v7.solid.faXmark" />
    </button>
  </div>
</template>
<script>
  export default {
    name: 'NudgeMessage',

    props: {
      ariaLabelClose: {
        type: String,
        default: 'Close'
      },
      content: {
        type: String,
        default: null
      },
      iconName: {
        type: String,
        default: null
      },
      iconRotation: {
        type: String,
        default: null
      },
      iconStyle: {
        type: String,
        default: 'solid'
      },
      title: {
        type: String,
        default: null
      },
      pointerOrientationX: {
        type: String,
        default: 'left'
      },
      pointerOrientationY: {
        type: String,
        default: 'top'
      },
      pointerPositionX: {
        type: String,
        default: '-0.5rem'
      }
    },

    computed: {
      hasContent() {
        return this.content
      },
      hasIcon() {
        return this.iconName
      },
      hasTitle() {
        return this.title
      },
      componentClass() {
        return [`nudge message blue with-close position-relative `, { 'with-icon': this.hasIcon }]
      },
      componentStyle() {
        let style = {}
        style['--message-margin'] = 'var(--spacing-md) var(--spacing-2xl)'
        style[`--nudge-pointer-orientation-${this.pointerOrientationX}`] = `${this.pointerPositionX}`
        style[`--nudge-pointer-orientation-${this.pointerOrientationY}`] = 'calc((var(--nudge-arrow-size) / 2) * -1)'

        return {
          ...style
        }
      }
    },

    methods: {
      dismissNudge() {
        this.$emit('dismiss-nudge')
      }
    }
  }
</script>
